module.exports = __webpack_public_path__ + "static/media/qr_guestlist-rsvp.a00d35de.svg";